const OurNetwork = {
  title: 'Our Network',
}

export default OurNetwork;